import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[preventDefault]'
})
export class PreventDefaultDirective {

  constructor() { }

  @HostListener('click', ['$event'])
  preventDefault(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

}

